/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TapeGroup,
    TapeGroupFromJSON,
    TapeGroupFromJSONTyped,
    TapeGroupToJSON,
} from './';

/**
 * 
 * @export
 * @interface TapeJob
 */
export interface TapeJob {
    /**
     * 
     * @type {TapeGroup}
     * @memberof TapeJob
     */
    group?: TapeGroup;
    /**
     * 
     * @type {number}
     * @memberof TapeJob
     */
    id?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof TapeJob
     */
    exclude?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TapeJob
     */
    selectedTape?: string;
    /**
     * 
     * @type {string}
     * @memberof TapeJob
     */
    hasCopy2?: string;
    /**
     * 
     * @type {string}
     * @memberof TapeJob
     */
    copy2Id?: string;
    /**
     * 
     * @type {string}
     * @memberof TapeJob
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof TapeJob
     */
    copied?: string;
    /**
     * 
     * @type {string}
     * @memberof TapeJob
     */
    total?: string;
    /**
     * 
     * @type {string}
     * @memberof TapeJob
     */
    type?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TapeJob
     */
    _export?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TapeJob
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof TapeJob
     */
    duration?: string;
    /**
     * 
     * @type {string}
     * @memberof TapeJob
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof TapeJob
     */
    destination?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TapeJob
     */
    deleteSource?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TapeJob
     */
    destination2?: string;
    /**
     * 
     * @type {string}
     * @memberof TapeJob
     */
    group2?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TapeJob
     */
    export2?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TapeJob
     */
    md5?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TapeJob
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof TapeJob
     */
    logPath?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TapeJob
     */
    logExists?: boolean;
}

export function TapeJobFromJSON(json: any): TapeJob {
    return TapeJobFromJSONTyped(json, false);
}

export function TapeJobFromJSONTyped(json: any, ignoreDiscriminator: boolean): TapeJob {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'group': !exists(json, 'group') ? undefined : TapeGroupFromJSON(json['group']),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'selectedTape': !exists(json, 'selected_tape') ? undefined : json['selected_tape'],
        'hasCopy2': !exists(json, 'has_copy2') ? undefined : json['has_copy2'],
        'copy2Id': !exists(json, 'copy2_id') ? undefined : json['copy2_id'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'copied': !exists(json, 'copied') ? undefined : json['copied'],
        'total': !exists(json, 'total') ? undefined : json['total'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        '_export': !exists(json, 'export') ? undefined : json['export'],
        'start': !exists(json, 'start') ? undefined : json['start'],
        'duration': !exists(json, 'duration') ? undefined : json['duration'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'destination': !exists(json, 'destination') ? undefined : json['destination'],
        'deleteSource': !exists(json, 'delete_source') ? undefined : json['delete_source'],
        'destination2': !exists(json, 'destination2') ? undefined : json['destination2'],
        'group2': !exists(json, 'group2') ? undefined : json['group2'],
        'export2': !exists(json, 'export2') ? undefined : json['export2'],
        'md5': !exists(json, 'md5') ? undefined : json['md5'],
        'startDate': !exists(json, 'start_date') ? undefined : json['start_date'],
        'logPath': !exists(json, 'log_path') ? undefined : json['log_path'],
        'logExists': !exists(json, 'log_exists') ? undefined : json['log_exists'],
    };
}

export function TapeJobToJSON(value?: TapeJob | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'group': TapeGroupToJSON(value.group),
        'id': value.id,
        'exclude': value.exclude,
        'selected_tape': value.selectedTape,
        'has_copy2': value.hasCopy2,
        'copy2_id': value.copy2Id,
        'status': value.status,
        'copied': value.copied,
        'total': value.total,
        'type': value.type,
        'export': value._export,
        'start': value.start,
        'duration': value.duration,
        'name': value.name,
        'destination': value.destination,
        'delete_source': value.deleteSource,
        'destination2': value.destination2,
        'group2': value.group2,
        'export2': value.export2,
        'md5': value.md5,
        'start_date': value.startDate,
        'log_path': value.logPath,
        'log_exists': value.logExists,
    };
}


